module.exports = __webpack_public_path__ + "static/media/Sun.0402426a.svg";